import mergeObject from './mergeObject.js';
import removeDirectives from './removeDirectives.js';

mergeObject.removeDirectives = removeDirectives;

export default mergeObject;
